import gql from "graphql-tag";

export const Todo = gql`
  mutation todo($input: TodoInput!) {
    Todo(input: $input) {
      id
      title
      desc
      done
      date_created
      assigned_userId
      assigned_user_fullname
      client_id
      client_fullname
      todo_assigned_done
    }
  }
`;

export const DeleteTodo = gql`
  mutation deleteTodo($input: DeleteTodoInput!) {
    DeleteTodo(input: $input) {
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/queries/todo/mutations.js